import { render, staticRenderFns } from "./AcsJournalList.vue?vue&type=template&id=54ec531a&scoped=true&lang=pug"
import script from "./AcsJournalList.vue?vue&type=script&lang=js"
export * from "./AcsJournalList.vue?vue&type=script&lang=js"
import style0 from "./AcsJournalList.vue?vue&type=style&index=0&id=54ec531a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec531a",
  null
  
)

export default component.exports